

function Projects() {
  return (
    <div className='projects-container'>
        <h1>My Projects</h1>
        <div>
          <a href='/Cat-Meme-Generator/index.html' target='_blank' rel='noopener noreferrer'>Cat Meme Generator</a>
          <a href='https://github.com/Jonathan-MacDuff/Cat-Meme-Generator' target='_blank' rel='noopener noreferrer'>Github Link</a>
          <p>This application is designed to generate random cat memes in three varieties utilizing public APIs.</p>
        </div>
        <div>
          <a href='/Pet-Finder/index.html' target='_blank' rel='noopener noreferrer'>Pet Finder</a>
          <a href='https://github.com/Jonathan-MacDuff/Pet-Finder-V2' target='_blank' rel='noopener noreferrer'>Github Link</a>
          <p>This application is designed to allow users to interact with eachother via  messages and comments to find and report lost pets.</p>
        </div>
    </div>
  );
};

export default Projects;